<template>
    <section>
        <div class="row">
            <div class="col-12">
                <inventory-stock-list></inventory-stock-list>
            </div>
        </div>
    </section>
</template>

<script>
import InventoryStockList from '@/components/inventory/StockList';
import DBSupplier from '@/database/Supplier';

export default {
    components: {
        InventoryStockList
    },
    mounted() {
        this.detectSupplier();
    },
    methods: {
        async detectSupplier() {
            const result = await DBSupplier.get();

            if (result.content.length === 0) {
                this.$swal({
                    title: 'ร้านค้าของท่านยังไม่มีรานชื่อซัพพลายเออร์',
                    text: 'โปรดทำการเพิ่มซัพพลายเออร์เนื่องจากเป็นส่วนหนึ่งของข้อมูลสำหรับการนำเข้าสต๊อคสินค้า',
                    icon: 'warning',
                    confirmButtonText: 'ไปเพิ่มซัพพลายเออร์',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.$router.push('/supplier');
                    }
                });
            }
        }
    }
}
</script>